//
// Generated class AnalyticAccount
//

/// <reference path="AnalyticAccount_ManagedObject.ts" />

class AnalyticAccount extends AnalyticAccount_ManagedObject
{
    get titlePath():string { return this.indentPathForKey( "title", "parent" )[0]; }
    get indentLevel():number { return this.indentPathForKey( "title", "parent" )[1]; }
}
